module.exports = __webpack_public_path__ + "static/media/CRC15__W.848be3f4.woff";